<template>
  <div>
    <vs-prompt
      :class="['sow-line-item-description-modal', subModalZClass]"
      :title="lineItemDescriptionEditing && lineItemDescriptionEditing.WasCompleted ? 'View Description' : 'Edit Description'"
      :active.sync="lineItemDescriptionModalActive"
      @accept="SaveLineItemDescriptionModal"
      @cancel="CloseLineItemDescriptionModal"
      :accept-text="lineItemDescriptionEditing && lineItemDescriptionEditing.WasCompleted ? 'Close' : 'Save'"
      cancel-text="Cancel"
    >
      <vs-textarea v-model="lineItemDescriptionDraft" rows="8" :readonly="lineItemDescriptionEditing && lineItemDescriptionEditing.WasCompleted"></vs-textarea>
    </vs-prompt>
    <vs-prompt
      :class="['line-item-move-modal', subModalZClass]"
      title="Move Line Item"
      :active.sync="lineItemMoveModalActive"
      @accept="MoveLineItem"
      @cancel="CloseLineItemMoveModal"
      accept-text="Move"
      cancel-text="Cancel"
      :is-valid="lineItemMoveSOWID != null && !movingLineItem"
    >
      <vs-row>
        <vs-col class="p-1 mt-1" vs-lg="12" vs-md="12" vs-sm="12">
          <label>Client:</label>
          <v-select
            v-model="lineItemMoveClientID"
            :options="clientList"
            :reduce="x => x.ClientID"
            label="ClientName"
            @input="lineItemMoveSOWID = null"
          />
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col class="p-1 mt-1" vs-lg="12" vs-md="12" vs-sm="12">
          <label>SOW:</label>
          <v-select
            v-model="lineItemMoveSOWID"
            :options="lineItemMoveSOWOptions"
            :reduce="x => x.SOWID"
            label="SOWName"
            placeholder="Select SOW"
          />
        </vs-col>
      </vs-row>
    </vs-prompt>
    <vs-prompt
      color="primary"
      :title="typeof selectedSOW.SOWNumber != 'undefined' ? (selectedSOW.SOWNumber+' - '+selectedSOW.SOWName) : 'Add SOW'"
      :class="['sow-modal', mainModalZClass]"
      :active.sync="sowPromptActive"
      :buttons-hidden="true"
    >
      <div class="sow-modal-layout">
        <div ref="sowModalBody" class="sow-modal-body">
          <vs-row>
            <vs-col class="p-1 mt-1" vs-lg="4" vs-md="4" vs-sm="12">
              <label>Name: <span class="text-danger">*</span></label>
              <vs-input v-model="sowFieldsSOWName"></vs-input>
            </vs-col>
            <vs-col class="p-1 mt-1" vs-lg="4" vs-md="4" vs-sm="12">
              <label>Client: <span class="text-danger">*</span></label>
              <v-select @input="OnChangedClient" v-model="sowFieldsClientID" :options="clientList" :reduce="x => x.ClientID" label="ClientName"></v-select>
            </vs-col>
            <vs-col class="p-1 mt-1" vs-lg="4" vs-md="4" vs-sm="12">
              <label>Category: <span class="text-danger">*</span></label>
              <div class="flex items-end" v-if="!creatingCategory">
                <v-select :disabled="sowFieldsClientID == null" :options="categoryList" :reduce="x => x.CategoryID" label="CategoryName" v-model="sowFieldsCategoryID" placeholder="Category" class="flex-grow" />
                <vs-button v-if="sowFieldsClientID" @click="BeginCreateCategory" icon-pack="feather" icon="icon-plus" class="ml-2"></vs-button>
              </div>
              <form class="flex items-end" v-else @submit.stop.prevent="CreateCategory" @keydown.esc.prevent="CancelCreateCategory">
                <vs-input ref="newCategoryInput" v-model="newCategory" class="flex-grow mr-2" @keydown.enter.native.prevent="CreateCategory"></vs-input>
                <vs-button @click="CancelCreateCategory" icon-pack="feather" icon="icon-x" class="mr-1"></vs-button>
                <vs-button @click="CreateCategory" :disabled="savingCategory" icon-pack="feather" icon="icon-arrow-right" type="submit"></vs-button>
              </form>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col class="p-1 mt-1" vs-lg="4" vs-md="4" vs-sm="12">
              <label>Overage Status:</label>
              <v-select v-model="sowFieldsOverageStatusID" :options="sowOverageStatusLookups" label="LookupValue" :reduce="x => x.LookupID"></v-select>
            </vs-col>
            <vs-col class="p-1 mt-1" vs-lg="4" vs-md="4" vs-sm="12">
              <label>Status:</label>
              <v-select :disabled="sowFieldsSOWID == null" v-model="sowFieldsSOWStatusID" :options="sowStatusLookups" label="LookupValue" :reduce="x => x.LookupID"></v-select>
            </vs-col>

            <vs-col class="p-1 mt-1" vs-lg="4" vs-md="4" vs-sm="12">
              <label>Managed By:</label>
              <v-select
                v-model="sowFieldsManagedByID"
                :options="workerList"
                :reduce="x => x.WorkerID"
                label="WorkerName"
              />
            </vs-col>

          </vs-row>
          <vs-row>
            <vs-col class="p-1 mt-1" vs-lg="4" vs-md="6" vs-sm="6">
              <label>DevOps Release Definition</label>
              <v-select v-model="sowFieldsDevOpsReleaseID" :options="devOpsReleaseDefs" label="DisplayName" :reduce="x => x.DevOpsReleaseID"></v-select>
            </vs-col>

            <vs-col class="p-1 mt-1" vs-lg="8" vs-md="8" vs-sm="12">
              <label>Sharepoint Link</label>
              <vs-input v-model="sowFieldsDescriptionURL"></vs-input>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col class="p-1 mt-1" vs-lg="12" vs-md="12" vs-sm="12">
              <label>Description: <span class="text-danger">*</span></label>
              <vs-textarea v-model="sowFieldsSOWDescription" class="sow-modal-description mt-2" height="8rem"></vs-textarea>
            </vs-col>
          </vs-row>

          <div class="p-1">
            <b>Tasks</b>
            <div class="line-items mt-2">
              <vs-row class="p-2">
                <vs-col class="p-1 mt-1" vs-lg="4" vs-md="4" vs-sm="4">
                  Title
                </vs-col>
                <vs-col class="p-1 mt-1" vs-lg="2" vs-md="2" vs-sm="2">
                  Description
                </vs-col>
                <vs-col class="p-1 mt-1" vs-lg="1" vs-md="1" vs-sm="1">
                  Estimate
                </vs-col>
                <vs-col class="p-1 mt-1" vs-lg="2" vs-md="2" vs-sm="2">
                  Assigned To
                </vs-col>
                <vs-col class="p-1 mt-1" vs-lg="2" vs-md="2" vs-sm="2">
                  Completed
                </vs-col>
                <vs-col class="p-1 mt-1" vs-lg="1" vs-md="1" vs-sm="1">

                </vs-col>
              </vs-row>
              <vs-row v-for="(item, index) in lineItems" :key="index" class="line-item-row px-2">
                <vs-col class="p-1 flex" vs-lg="4" vs-md="4" vs-sm="4">
                  <vs-input ref="lineItemTitleInput" @input="SetLineItemDirty(item)" v-model="item.Title" :disabled="item.WasCompleted" class="sow-line-item-title-input"></vs-input>
                </vs-col>
                <vs-col class="p-1 flex items-center" vs-lg="2" vs-md="2" vs-sm="2">
                  <vs-input readonly @input="SetLineItemDirty(item)" v-model="item.Description" :disabled="item.WasCompleted" :title="item.Description"></vs-input>
                  <vs-button v-if="!item.WasCompleted" type="flat" size="small" icon-pack="feather" icon="icon-edit" @click="OpenLineItemDescriptionModal(item)" class="sow-line-item-details-btn"></vs-button>
                  <vs-button v-else type="flat" size="small" icon-pack="feather" icon="icon-eye" @click="OpenLineItemDescriptionModal(item)" class="sow-line-item-details-btn"></vs-button>
                </vs-col>
                <vs-col class="p-1" vs-lg="1" vs-md="1" vs-sm="1">
                  <vs-input @input="SetLineItemDirty(item)" v-model="item.TimeEstimate" :disabled="item.WasCompleted"></vs-input>
                </vs-col>
                <vs-col class="p-1" vs-lg="2" vs-md="2" vs-sm="2">
                  <v-select
                    @input="SetLineItemDirty(item)"
                    v-model="item.AssignedTo"
                    :class="{
                      'dropdown-disabled': item.WasCompleted,
                    }"
                    :options="workerList"
                    :reduce="x => x.WorkerID"
                    label="WorkerName"
                  />
                </vs-col>
                <vs-col class="p-1 flex align-center" vs-lg="2" vs-md="2" vs-sm="2">
                  <span v-if="item.CompletedByName != null && item.CompletedByName.length > 0" class="px-2">{{ item.CompletedByName }}</span>
                  <span v-if="item.CompletedByName != null && item.CompletedByName.length > 0" class="px-2">{{ DateFormatted(item.CompletedOn) }}</span>
                  <vs-checkbox @input="SetLineItemDirty(item)" v-else v-model="item.IsCompleted" :disabled="item.AssignedTo != workerID">Completed</vs-checkbox>
                </vs-col>
                <vs-col class="p-1 sow-line-item-actions-col" vs-lg="1" vs-md="1" vs-sm="1">
                  <div class="sow-line-item-actions">
                    <vs-button :disabled="item.deleting || !item.SOWLineItemID" @click="OpenLineItemMoveModal(item)" color="primary" icon-pack="feather" icon="icon-external-link" class="sow-line-item-action-btn"></vs-button>
                    <vs-button v-if="item.confirmDelete" type="border" color="primary" icon-pack="feather" icon="icon-x" @click="$set(item, 'confirmDelete', null)" class="sow-line-item-action-btn"></vs-button>
                    <vs-button :disabled="item.deleting || item.WasCompleted" @click="DeleteLineItem(item)" color="danger" icon-pack="feather" :icon="item.confirmDelete ? 'icon-check' : 'icon-trash'" class="sow-line-item-action-btn"></vs-button>
                  </div>
                </vs-col>
              </vs-row>
            </div>
            <vs-button icon-pack="feather" icon="icon-plus" @click="CreateLineItem()" class="mt-3" size="small">New Line Item</vs-button>
          </div>
        </div>

        <div class="sow-modal-footer modal-footer">
          <div class="sow-modal-footer-left">
            <vs-button
              v-if="selectedSOW.SOWID != null && selectedSOW.confirmDelete"
              type="border"
              color="primary"
              icon-pack="feather"
              icon="icon-x"
              @click="$set(selectedSOW, 'confirmDelete', null)"
              class="mr-2 mt-2">
            </vs-button>
            <vs-button v-if="selectedSOW.SOWID != null" :disabled="selectedSOW.deleting" @click="DeleteSOW()" color="danger" icon-pack="feather" :icon="selectedSOW.confirmDelete ? 'icon-check' : 'icon-trash'" class="mt-2"></vs-button>
          </div>
          <div class="sow-modal-footer-right">
            <vs-button v-if="selectedSOW.SOWID" :disabled="generatingSOWPDF" @click="GeneratePDF('html')" class="mr-2 mt-2">Preview PDF</vs-button>
            <vs-button v-if="selectedSOW.SOWID" :disabled="generatingSOWPDF" @click="GeneratePDF('chrome-pdf')" class="mr-2 mt-2">Generate PDF</vs-button>
            <div v-if="selectedSOW.SOWID" class="sow-modal-footer-divider"></div>
            <vs-button :disabled="savingSOW || !canSaveSOW" @click="SaveSOW()" class="mr-2 mt-2">{{ savingSOW ? 'Saving...' : 'Save' }}</vs-button>
            <vs-button @click="sowPromptActive = false" type="flat" color="secondary" class="mt-2">Cancel</vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>
    <vs-prompt
      :class="['sow-preview-modal', subModalZClass]"
      title="Preview Report"
      :active.sync="previewReportOpen"
      @accept="GeneratePDF('chrome-pdf')"
    >
      <div v-html="previewReportHTML"></div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import Vue from 'vue'
const moment = require('moment')

export default {
  name: 'SOWModal',
  components: {
    'v-select': vSelect
  },
  props: {
    baseLayer: {
      type: Number,
      default: 0
    },
    defaultClientID: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      selectedSOW: {},
      sowFieldsEpicID: null,
      sowFieldsProjectID: null,
      sowFieldsClientID: null,
      sowFieldsSOWID: null,
      sowFieldsSOWName: null,
      sowFieldsSOWDescription: null,
      sowFieldsDevOpsReleaseID: null,
      sowFieldsSOWNumber: null,
      sowFieldsCategoryID: null,
      sowFieldsOverageStatusID: null,
      sowFieldsManagedByID: null,
      sowFieldsSOWStatusID: null,
      sowFieldsDescriptionURL: null,
      sowEpicId: null,
      sowPromptActive: false,
      completedStatusNames: ['Release Approved', 'Complete'],
      lineItems: [],
      savingSOW: false,
      generatingSOWPDF: false,
      previewReportOpen: false,
      previewReportHTML: null,
      creatingCategory: false,
      newCategory: '',
      savingCategory: false,
      lineItemDescriptionModalActive: false,
      lineItemDescriptionEditing: null,
      lineItemDescriptionDraft: '',
      lineItemMoveModalActive: false,
      lineItemMoveEditing: null,
      lineItemMoveClientID: null,
      lineItemMoveSOWID: null,
      movingLineItem: false
    }
  },
  computed: {
    mainModalZClass () {
      if (this.baseLayer >= 1) return 'z-modal-2'
      return ''
    },
    subModalZClass () {
      if (this.baseLayer >= 1) return 'z-modal-3'
      return 'z-modal-2'
    },
    devOpsReleaseDefs () {
      return this.$store.getters.GetDevOpsReleaseDefs
    },
    canSaveSOW () {
      if (this.sowFieldsClientID == null) return false
      if (this.sowFieldsCategoryID == null) return false
      if (this.sowFieldsSOWName == null || this.sowFieldsSOWName == '') return false
      if (this.sowFieldsSOWDescription == null || this.sowFieldsSOWDescription == '') return false
      return true
    },
    rawCategoryList () {
      return this.$store.getters.GetCategoryList
    },
    categoryList () {
      if (this.sowFieldsClientID == null) {
        return this.rawCategoryList
      }
      return this.rawCategoryList.filter(x => x.ClientID == this.sowFieldsClientID)
    },
    clientList () {
      return this.$store.getters.GetClientList
    },
    sowStatusLookups () {
      return this.$store.getters.GetSOWStatusLookups.filter(x => x.StatusPermission == 1)
    },
    sowOverageStatusLookups () {
      return this.$store.getters.GetSOWOverageStatusLookups
    },
    workerID () {
      return this.$store.getters.GetWorkerID
    },
    sowList () {
      return this.$store.getters.GetSOWList
    },
    workerList () {
      return this.$store.getters.GetWorkerList
    },
    lineItemMoveSOWOptions () {
      if (this.lineItemMoveClientID == null) return []
      const currentSOWID = this.lineItemMoveEditing ? this.lineItemMoveEditing.SOWID : null
      return this.sowList.filter(x => x.ClientID == this.lineItemMoveClientID && x.SOWID !== currentSOWID)
    }
  },
  watch: {
    sowFieldsClientID (newVal) {
      if (newVal == null) {
        this.creatingCategory = false
      }
    },
    selectedSOW () {
      this.UpdateSelectedSOW()
    },
    sowPromptActive (val) {
      if (!val) {
        this.$emit('closed')
      }
    },
    sowFieldsSOWStatusID (n, o) {
      setTimeout(() => {
        if (n == null) return
        const nLookup = this.sowStatusLookups.find(x => x.LookupID == n)
        if (nLookup == null) return
        const nName = nLookup.LookupValue
        if (this.completedStatusNames.indexOf(nName) !== -1) {
          const unarchived = this.lineItems
          const allCompleted = unarchived.length === 0 || unarchived.every(li => li.WasCompleted || li.IsCompleted)
          if (!allCompleted) {
            this.sowFieldsSOWStatusID = o
            this.$vs.notify({
              color: 'warning',
              title: 'Cannot set status to completed until all unarchived line items are marked completed.'
            })
          }
        }
      }, 5)
    }
  },
  methods: {
    OpenForCreate () {
      this.selectedSOW = {}
      this.lineItems = []
      this.sowFieldsClientID = this.defaultClientID != null ? this.defaultClientID : null
      this.sowFieldsProjectID = null
      this.sowFieldsEpicID = null
      this.sowFieldsSOWID = null
      this.sowFieldsSOWName = null
      this.sowFieldsSOWDescription = null
      this.sowFieldsSOWNumber = null
      this.sowFieldsCategoryID = null
      this.sowFieldsOverageStatusID = null
      this.sowFieldsSOWStatusID = this.sowStatusLookups[0] ? this.sowStatusLookups[0].LookupID : null
      this.sowFieldsDescriptionURL = null
      this.sowFieldsDevOpsReleaseID = null
      this.sowFieldsManagedByID = null
      this.sowPromptActive = true
      this.DisableUnderlyingDialogs()
    },
    OpenForSOW (sow) {
      this.selectedSOW = sow != null ? sow : {}
      if (this.selectedSOW && this.selectedSOW.SOWID != null) {
        this.GetLineItems(this.selectedSOW.SOWID)
      } else {
        this.lineItems = []
      }
      this.sowPromptActive = true
      this.DisableUnderlyingDialogs()
    },
    DisableUnderlyingDialogs () {
      setTimeout(() => {
        Array.from(document.getElementsByClassName('vs-dialog-dark')).forEach(function (x) {
          x.style.pointerEvents = 'none'
        })
      }, 100)
    },
    BeginCreateCategory () {
      this.creatingCategory = true
      this.$nextTick(() => {
        const ref = this.$refs.newCategoryInput
        const input = ref && ref.$el && ref.$el.querySelector('input')
        if (input) input.focus()
      })
    },
    CancelCreateCategory () {
      this.creatingCategory = false
      this.newCategory = ''
    },
    async CreateCategory () {
      this.savingCategory = true
      try {
        await this.$store.dispatch('ActionSaveCategory', { CategoryName: this.newCategory, ClientID: this.sowFieldsClientID })
        await this.$store.dispatch('ActionFetchCategories')
        setTimeout(() => {
          const created = this.categoryList.find(x => x.CategoryName == this.newCategory)
          if (created) this.sowFieldsCategoryID = created.CategoryID
          this.newCategory = ''
        }, 10)
      } catch (e) {
        console.error(e)
      }
      this.savingCategory = false
      this.creatingCategory = false
    },
    UpdateSelectedSOW () {
      const sowFields = JSON.parse(JSON.stringify(this.selectedSOW))
      if (sowFields.SOWID == null) return
      this.sowFieldsClientID = sowFields.ClientID
      this.sowFieldsProjectID = sowFields.ProjectID
      this.sowFieldsEpicID = sowFields.JiraEpicID
      this.sowFieldsSOWID = sowFields.SOWID
      this.sowFieldsSOWName = sowFields.SOWName
      this.sowFieldsSOWDescription = sowFields.SOWDescription
      this.sowFieldsDevOpsReleaseID = sowFields.DevOpsReleaseID
      this.sowFieldsSOWNumber = sowFields.SOWNumber
      this.sowFieldsCategoryID = sowFields.CategoryID
      this.sowFieldsOverageStatusID = sowFields.OverageStatusID
      this.sowFieldsManagedByID = sowFields.ManagedByID
      this.sowFieldsSOWStatusID = sowFields.SOWStatusID
      this.sowFieldsDescriptionURL = sowFields.DescriptionURL
    },
    OnChangedClient (clientId) {
      if (clientId == null) {
        this.sowFieldsProjectID = null
        this.sowFieldsEpicID = null
      }
    },
    async GeneratePDF (reportType) {
      this.generatingSOWPDF = true
      try {
        const resp = await this.$store.dispatch('ActionGenerateSOWReport', {
          sowId: this.selectedSOW.SOWID,
          reportType: reportType
        })
        if (reportType == 'html') {
          this.previewReportHTML = resp
          this.previewReportOpen = true
        }
      } catch (e) {}
      this.generatingSOWPDF = false
      if (reportType == 'chrome-pdf') {
        this.previewReportOpen = false
      } else if (reportType == 'html') {
        this.sowPromptActive = false
      }
    },
    OpenLineItemDescriptionModal (item) {
      this.lineItemDescriptionEditing = item
      this.lineItemDescriptionDraft = item.Description != null ? item.Description : ''
      this.lineItemDescriptionModalActive = true
    },
    SaveLineItemDescriptionModal () {
      if (this.lineItemDescriptionEditing && !this.lineItemDescriptionEditing.WasCompleted) {
        this.$set(this.lineItemDescriptionEditing, 'Description', this.lineItemDescriptionDraft)
        this.SetLineItemDirty(this.lineItemDescriptionEditing)
      }
      this.CloseLineItemDescriptionModal()
    },
    CloseLineItemDescriptionModal () {
      this.lineItemDescriptionEditing = null
      this.lineItemDescriptionDraft = ''
    },
    OpenLineItemMoveModal (item) {
      this.lineItemMoveEditing = item
      this.lineItemMoveClientID = this.sowFieldsClientID != null ? this.sowFieldsClientID : item.ClientID
      this.lineItemMoveSOWID = null
      this.lineItemMoveModalActive = true
    },
    CloseLineItemMoveModal () {
      this.lineItemMoveModalActive = false
      this.lineItemMoveEditing = null
      this.lineItemMoveSOWID = null
      this.lineItemMoveClientID = null
    },
    async MoveLineItem () {
      if (this.lineItemMoveEditing == null || this.lineItemMoveSOWID == null) return
      this.movingLineItem = true
      try {
        await this.$store.dispatch('ActionMoveLineItem', {
          SOWLineItemID: this.lineItemMoveEditing.SOWLineItemID,
          TargetSOWID: this.lineItemMoveSOWID
        })
        this.CloseLineItemMoveModal()
        this.GetLineItems(this.sowFieldsSOWID)
      } catch (e) {
        console.error(e)
      }
      this.movingLineItem = false
    },
    CreateLineItem () {
      this.lineItems.push({
        Title: '',
        Description: '',
        TimeEstimate: null,
        SOWID: null,
        IsCompleted: false,
        IsCompletedOriginal: false
      })
      this.$nextTick(() => {
        const body = this.$refs.sowModalBody
        if (body) body.scrollTop = body.scrollHeight
        const inputs = this.$refs.lineItemTitleInput
        const last = Array.isArray(inputs) ? inputs[inputs.length - 1] : inputs
        if (last && last.$el) {
          const input = last.$el.querySelector('input')
          if (input) input.focus()
        }
      })
    },
    DeleteLineItem (item) {
      if (item.SOWLineItemID && item.SOWLineItemID > 0) {
        if (item.confirmDelete == null) {
          Vue.set(item, 'confirmDelete', true)
          return
        }
        Vue.set(item, 'deleting', true)
        this.$store.dispatch('ActionDeleteLineItem', item.SOWLineItemID).finally(() => {
          Vue.set(item, 'deleting', false)
          this.GetLineItems(item.SOWID)
        })
      } else {
        this.lineItems = this.lineItems.filter(li => li !== item && !li.Archived)
      }
    },
    SaveLineItem (item) {
      Vue.set(item, 'saving', true)
      if (item.SOWID == null) item.SOWID = this.sowFieldsSOWID

      if (item.SOWLineItemID) {
        if (item.IsCompletedOriginal === true) {
          Vue.set(item, 'saving', false)
          return Promise.resolve()
        }
        return this.$store.dispatch('ActionSaveLineItem', item).finally(() => {
          Vue.set(item, 'saving', false)
        })
      }
      return this.$store.dispatch('ActionCreateLineItem', item).finally(() => {
        Vue.set(item, 'saving', false)
      })
    },
    SetLineItemDirty (item) {
      item.isDirty = true
    },
    SaveAllLineItems () {
      const dirtyItems = this.lineItems.filter(x => x.isDirty)
      if (dirtyItems.length === 0) return Promise.resolve()
      return Promise.all(dirtyItems.map(x => this.SaveLineItem(x)))
        .then(() => this.GetLineItems(this.sowFieldsSOWID))
    },
    SaveSOW () {
      if (!this.savingSOW) {
        this.savingSOW = true

        this.$store.dispatch('ActionSaveSOW', {
          ClientID: this.sowFieldsClientID,
          ProjectID: this.sowFieldsProjectID,
          JiraEpicID: null,
          SOWID: this.sowFieldsSOWID,
          SOWName: this.sowFieldsSOWName,
          SOWDescription: this.sowFieldsSOWDescription,
          SOWNumber: this.sowFieldsSOWNumber,
          CategoryID: this.sowFieldsCategoryID,
          OverageStatusID: this.sowFieldsOverageStatusID,
          SOWStatusID: this.sowFieldsSOWStatusID,
          DescriptionURL: this.sowFieldsDescriptionURL,
          ITATOwnerID: this.sowFieldsManagedByID,
          DevOpsReleaseID: this.sowFieldsDevOpsReleaseID
        }).then(response => {
          this.sowFieldsSOWID = response[0].SOWID
          this.SaveAllLineItems().then(() => {
            this.sowPromptActive = false
            const savedSOW = {
              SOWID: response[0].SOWID,
              SOWName: this.sowFieldsSOWName,
              SOWNumber: this.sowFieldsSOWNumber,
              ClientID: this.sowFieldsClientID,
              CategoryID: this.sowFieldsCategoryID
            }
            this.$emit('saved', savedSOW)
          }).catch(error => {
            const message = error && error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : 'SOW saved, but one or more line items failed to save. Please review and try again.'
            this.$vs.notify({
              color: 'danger',
              title: 'Save failed',
              text: message
            })
          })
        }).catch(error => {
          const message = error && error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Unable to save SOW. Please review and try again.'
          this.$vs.notify({
            color: 'danger',
            title: 'Save failed',
            text: message
          })
        }).finally(() => {
          this.savingSOW = false
        })
      } else {
        return
      }
    },
    DeleteSOW () {
      if (this.selectedSOW.confirmDelete == null) {
        Vue.set(this.selectedSOW, 'confirmDelete', true)
        return
      }
      Vue.set(this.selectedSOW, 'deleting', true)
      const sowId = this.selectedSOW.SOWID
      this.$store.dispatch('ActionDeleteSOW', sowId).finally(() => {
        Vue.set(this.selectedSOW, 'deleting', false)
        this.sowPromptActive = false
        this.$emit('deleted', sowId)
      })
    },
    GetLineItems (sowId) {
      return this.$store.dispatch('ActionFetchSOWLineItems', sowId).then(data => {
        this.lineItems = data.filter(li => !li.Archived)
        this.lineItems.forEach(x => {
          x.WasCompleted = x.IsCompleted
        })
      })
    },
    DateFormatted (date) {
      if (date == null) return ''
      return moment(date).format('MM/DD/YYYY')
    }
  }
}
</script>

<style lang="css">
.sow-modal.vs-dialog-primary .vs-dialog {
  max-width: 90% !important;
  height: 85vh !important;
  display: flex !important;
  flex-direction: column !important;
}

.sow-modal.vs-dialog-primary .vs-dialog header,
.sow-modal.vs-dialog-primary .vs-dialog footer {
  flex-shrink: 0;
}

.sow-modal.vs-dialog-primary .vs-dialog .vs-dialog-text {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 1rem;
}

.sow-modal-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.sow-modal-body {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.sow-modal-footer {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.sow-modal-footer-left,
.sow-modal-footer-right {
  display: flex;
  align-items: flex-end;
}

.sow-modal-footer-divider {
  width: 1px;
  align-self: stretch;
  min-height: 1rem;
  margin: 0.5rem 0.5rem 0 0;
  background: rgba(255, 255, 255, 0.15);
}

.sow-modal-description textarea {
  resize: vertical;
}

.sow-preview-modal.vs-dialog-primary .vs-dialog {
  max-width: 900px !important;
}

.line-item-move-modal.vs-dialog-primary .vs-dialog {
  max-width: 28rem !important;
  display: flex !important;
  flex-direction: column !important;
}

.line-item-move-modal.vs-dialog-primary .vs-dialog .vs-dialog-text {
  flex: 1 1 auto;
  min-height: 0;
  overflow: visible;
}

.line-item-move-modal.vs-dialog-primary .vs-dialog footer {
  margin-top: auto;
}

.line-items {
  background: #10163a69;
  border-radius: 5px;
}

.line-item-row:nth-child(even) {
  background: #ffffff05;
}
.line-item-row > div {
  min-width: 0;
}

.sow-line-item-title-input {
  flex: 1;
  min-width: 0;
}

.sow-line-item-details-btn {
  flex-shrink: 0;
  margin-left: 0.25rem;
}

.sow-line-item-actions-col {
  display: flex;
  align-items: center;
  align-self: stretch;
}

.sow-line-item-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  min-height: 100%;
  padding: 0.25rem 0;
  gap: 0.25rem;
}

.sow-line-item-actions .sow-line-item-action-btn {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.modal-footer {
  display: flex;
  float: right;
}
</style>
